// A guest's "I want position #N" intent, kept across signup -> subscribe -> pay.
// Stored as {position, at}; ignored after 24h. The old bare-number format is treated as expired.
export const PENDING_KEY = "samtwo_pending_position_claim";
const TTL_MS = 24 * 60 * 60 * 1000;
const EVT = "samtwo-pending-claim";

export const readPendingClaim = () => {
  let raw = null;
  try { raw = localStorage.getItem(PENDING_KEY); } catch { return null; }
  if (!raw) return null;
  try {
    const v = JSON.parse(raw);
    if (v && typeof v === "object" && Number.isInteger(v.position) && Date.now() - Number(v.at) < TTL_MS) return v.position;
  } catch { /* corrupt: fall through and clear */ }
  clearPendingClaim();
  return null;
};

export const savePendingClaim = (position) => {
  try { localStorage.setItem(PENDING_KEY, JSON.stringify({ position: Number(position), at: Date.now() })); } catch { /* noop */ }
  window.dispatchEvent(new Event(EVT));
};

export const clearPendingClaim = () => {
  try { localStorage.removeItem(PENDING_KEY); } catch { /* noop */ }
  window.dispatchEvent(new Event(EVT));
};

export const onPendingClaimChange = (fn) => {
  window.addEventListener(EVT, fn);
  window.addEventListener("storage", fn);
  return () => { window.removeEventListener(EVT, fn); window.removeEventListener("storage", fn); };
};
